import {actionMap} from '../reducers/index'
import handleError from 'shared/errorHandler/actions/handleError'
import {fetchApi} from "shared/actions/fetchApi"
import * as types from './types'

export default () => dispatch => {
    dispatch({type: types.GET_LOGIN_PAGE_URL_START})
    return fetchApi("/api/as/auth/redirect-url")
        .then(response => response.json())
        .then(response => {
            dispatch({
                type: types.GET_LOGIN_PAGE_URL_SUCCESS, response: response
            })
        })
        .catch(error => {
            dispatch({
                type: types.GET_LOGIN_PAGE_URL_FAILURE
            })
            dispatch(handleError({
                message: error.message,
                title: "Retrieving login page url failed"
            }))
        })
}

export const handler_GET_LOGIN_PAGE_URL_START = (reduxState) => {
    return ({
        ...reduxState
    })
}

export const handler_GET_LOGIN_PAGE_URL_SUCCESS = (reduxState, action) => {
    return ({
        ...reduxState,
        loginUrl: action.response.url
    })
}

export const handler_GET_LOGIN_PAGE_URL_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        loginUrl: undefined,
        isLoading: false
    })
}


actionMap[types.GET_LOGIN_PAGE_URL_START] = handler_GET_LOGIN_PAGE_URL_START
actionMap[types.GET_LOGIN_PAGE_URL_SUCCESS] = handler_GET_LOGIN_PAGE_URL_SUCCESS
actionMap[types.GET_LOGIN_PAGE_URL_FAILURE] = handler_GET_LOGIN_PAGE_URL_FAILURE


// WEBPACK FOOTER //
// ./src/screens/login/actions/getLoginPageUrl.js